import { Pagination, Box, Switch } from "@mui/material";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";
import moment from "moment";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import ManageUserDrawer from "./ManageUserDrawer";
import { useCallback, useEffect, useState, useRef } from "react";
import "../../../styles/font.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { createSearchParams, useLocation } from "react-router-dom";
import { usersRetreive, getSiteTraffic, updateIPFlagStatus } from "../../../actions/user";
import { useGetSettingByKeyQuery, useUpsertSettingMutation } from "../../../reducers/settingsApi";
import CustomeSelect from "../../../components/custome-select/CustomeSelect";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TrafficDetailDrawer from "./trafficDrawers/TrafficDetailDrawer";
import AlertConditionDrawer from "./trafficDrawers/AlertConditionDrawer";
import UserAlertsDrawer from "./trafficDrawers/UserAlertsDrawer";
import BlacklistIpsDrawer from "./trafficDrawers/BlacklistIpsDrawer";
import PublicIcon from "@mui/icons-material/Public";


const ManageUsers = () => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [sort, setSort] = useState("");
    // console.log("object", sort);
    const [open, setOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("site-traffic");
    const [trafficSearch, setTrafficSearch] = useState("");
    const [trafficDrawerOpen, setTrafficDrawerOpen] = useState(false);
    const [alertDrawerOpen, setAlertDrawerOpen] = useState(false);
    const [userAlertsDrawerOpen, setUserAlertsDrawerOpen] = useState(false);
    const [blacklistDrawerOpen, setBlacklistDrawerOpen] = useState(false);
    const [selectedTraffic, setSelectedTraffic] = useState(null);
    const [trafficSortBy, setTrafficSortBy] = useState("lastVisitAt");
    const [trafficSortDir, setTrafficSortDir] = useState("desc");

    // hooks
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Local State
    // Local State
    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);
    const [pagination, setpagination] = useState({
        currentPage: 1,
    });
    const [trafficPagination, setTrafficPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        count: 0
    });
    const [trafficData, setTrafficData] = useState([]);
    const [trafficLoading, setTrafficLoading] = useState(false);
    const { data: mapIpSettingRes } = useGetSettingByKeyQuery("app.setting.mapIp");
    const { data: blacklistSettingRes } = useGetSettingByKeyQuery("app.setting.backlistIp");
    const [upsertSetting] = useUpsertSettingMutation();
    const restrictedIps = Array.isArray(mapIpSettingRes?.data?.value) ? mapIpSettingRes.data.value : (mapIpSettingRes?.data?.value ? [mapIpSettingRes.data.value] : []);
    const blacklistedIps = Array.isArray(blacklistSettingRes?.data?.value) ? blacklistSettingRes.data.value : (blacklistSettingRes?.data?.value ? [blacklistSettingRes.data.value] : []);
    // console.log("object", pagination);
    const [SearchFillter, setSearchFillter] = useState({
        SearchQuery: "",
    });
    const [accountType, setAccountType] = useState("");

    // Api calls for get Order
    const getData = useCallback(
        async (pageNo, search, accountType, sort) => {
            const lowerCasedAccountType = accountType ? accountType.toLowerCase() : "";
            const res = await dispatch(usersRetreive(pageNo, search, lowerCasedAccountType, sort));
            // console.log("object", res?.users);
            setData(res?.users);
            setpagination({
                currentPage: 1, // Default value
                ...res?.pagination // Spread existing pagination if it exists
            });
            setloading(false);
        },
        [dispatch]
    );

    const getTrafficData = useCallback(
        async (pageNo, search, sortBy, sortDir) => {
            setTrafficLoading(true);
            const res = await dispatch(getSiteTraffic(pageNo, search, 20, sortBy, sortDir));
            if (res?.success) {
                setTrafficData(res?.data?.data || []);
                setTrafficPagination(res?.data?.pagination || { currentPage: 1, totalPages: 1, count: 0 });
            }
            setTrafficLoading(false);
        },
        [dispatch]
    );

    const refreshTrafficData = () => {
        getTrafficData(trafficPagination.currentPage, trafficSearch, trafficSortBy, trafficSortDir);
    };

    const handleToggleFlag = async (row, field, checked) => {
        setTrafficData((prev) => prev.map((item) => item.ip === row.ip ? { ...item, [field]: checked } : item));
        try {
            const payload = {
                flagged: !!row.flagged,
                sundialFlag: !!row.sundialFlag,
                googleCrawlFlag: !!row.googleCrawlFlag,
                isRestricted: !!row.isRestricted,
                blacklistIp: !!row.blacklistIp,
                [field]: checked
            };
            await dispatch(updateIPFlagStatus(row.ip, payload));

            if (field === 'isRestricted') {
                let updatedIps = [...restrictedIps];
                if (checked && !updatedIps.includes(row.ip)) {
                    updatedIps.push(row.ip);
                } else if (!checked) {
                    updatedIps = updatedIps.filter(ip => ip !== row.ip);
                }

                await upsertSetting({
                    key: "app.setting.mapIp",
                    value: updatedIps,
                    description: "List of map Ips",
                    category: "app",
                    isPublic: true
                }).unwrap();
            } else if (field === 'blacklistIp') {
                let updatedIps = [...blacklistedIps];
                if (checked && !updatedIps.includes(row.ip)) {
                    updatedIps.push(row.ip);
                } else if (!checked) {
                    updatedIps = updatedIps.filter(item => item !== row.ip);
                }

                await upsertSetting({
                    key: "app.setting.backlistIp",
                    value: updatedIps,
                    description: "List of map Ips",
                    category: "app",
                    isPublic: true
                }).unwrap();
            }
        } catch (error) {
            setTrafficData((prev) => prev.map((item) => item.ip === row.ip ? { ...item, [field]: !checked } : item));
        }
    };

    const handleTrafficSort = (column) => {
        if (trafficSortBy === column) {
            setTrafficSortDir(trafficSortDir === "asc" ? "desc" : "asc");
        } else {
            setTrafficSortBy(column);
            setTrafficSortDir("desc");
        }
    };

    const getSortIcon = (column) => {
        if (trafficSortBy !== column) {
            return <UnfoldMoreIcon style={{ fontSize: "14px", color: "#BBBBBB", marginLeft: "2px" }} />;
        }
        if (trafficSortDir === "asc") {
            return <ArrowUpwardIcon style={{ fontSize: "14px", color: "#1D1D1B", marginLeft: "2px" }} />;
        }
        return <ArrowDownwardIcon style={{ fontSize: "14px", color: "#1D1D1B", marginLeft: "2px" }} />;
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tab = urlParams.get("tab");
        const page = parseInt(urlParams.get("page")) || 1;

        if (tab && tab !== activeTab) {
            setActiveTab(tab);
        }

        if (tab === "site-traffic" || (!tab && activeTab === "site-traffic")) {
            if (page !== trafficPagination.currentPage) {
                setTrafficPagination(prev => ({ ...prev, currentPage: page }));
            }
        } else {
            if (page !== pagination.currentPage) {
                setpagination(prev => ({ ...prev, currentPage: page }));
            }
        }
    }, [location.search]);

    useEffect(() => {
        if (activeTab === "site-traffic") {
            const timer = setTimeout(() => {
                getTrafficData(trafficPagination.currentPage, trafficSearch, trafficSortBy, trafficSortDir);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [activeTab, trafficPagination.currentPage, trafficSearch, trafficSortBy, trafficSortDir, getTrafficData, pagination.currentPage]);

    useEffect(() => {
        var isSubscribe = true;
        if (isSubscribe) {
            var timer = setTimeout(() => {
                getData(pagination.currentPage, SearchFillter?.SearchQuery, accountType, sort);
            }, 1000);
        }

        return () => {
            isSubscribe = false;
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.currentPage, SearchFillter?.SearchQuery, loading, accountType, sort]);


    // Handle account type change
    const handleAccountTypeChange = (value) => {
        setAccountType(value);
        // getUsers(pagination.currentPage, SearchFillter?.SearchQuery,value);
    };


    const handleSearchChange = (event) => {
        setTrafficSearch(event.target.value);
    };



    const openManageUserDrawer = (item) => {
        setSelectedItem(item); // Store selected item
        setOpen(true); // Open drawer
    };

    const closeManageUserDrawer = () => {
        setOpen(false);
        setSelectedItem(null); // Reset selected item
    };

    const handleEmailClick = (email) => {
        setActiveTab("customers");
        resetCustomersToFirstPage();
        setSearchFillter({ ...SearchFillter, SearchQuery: email });
        setTrafficDrawerOpen(false);
    };

    const resetCustomersToFirstPage = () => {
        setpagination((prev) => ({ ...prev, currentPage: 1 }));
        navigate({
            pathname: location.pathname,
            search: `?${createSearchParams({ page: 1, tab: "customers" })}`,
        }, { replace: true });
    };

    const resetTrafficToFirstPage = () => {
        setTrafficPagination((prev) => ({ ...prev, currentPage: 1 }));
        navigate({
            pathname: location.pathname,
            search: `?${createSearchParams({ page: 1, tab: "site-traffic" })}`,
        }, { replace: true });
    };

    // handle page change
    const handleChange = (e, value) => {
        const options = {
            pathname: location.pathname,
            search: `?${createSearchParams({ page: value, tab: activeTab })}`,
        };
        navigate(options, { replace: true });
        if (activeTab === "site-traffic") {
            setTrafficPagination({ ...trafficPagination, currentPage: value });
        } else {
            setpagination({ ...pagination, currentPage: value });
        }
    };


    const getStatusClass = (status) => {
        // console.log("object", status);
        switch (status) {
            case "rejected":
                return "bg-rejected text-rejected border-rejected";
            case "approved":
                return "bg-approved text-approved border-approved";
            case "Not Applied":
                return "bg-light text-secondary border-secondary";
            default:
                return "bg-pending text-pending border-pending";
        }
    };

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        }, [value]);
        return ref.current;
    }

    const prevOpen = usePrevious(open);

    useEffect(() => {
        if (prevOpen && !open) {
            getData(pagination.currentPage, SearchFillter?.SearchQuery, accountType, sort);
        }
    }, [open, prevOpen, getData, pagination.currentPage, SearchFillter?.SearchQuery, accountType, sort]);


    const UserTabs = ({ activeTab, onTabChange }) => {
        const tabs = [
            { id: 'site-traffic', label: 'All Site Traffic' },
            { id: 'customers', label: 'Customers' },
        ];

        return (
            <div className="d-flex mb-4" style={{ gap: "40px" }}>
                {tabs.map((tab) => (
                    <div
                        key={tab.id}
                        className={`pb-2 cursor-pointer sofiaBold`}
                        style={{
                            cursor: 'pointer',
                            fontSize: '20px',
                            color: activeTab === tab.id ? '#1D1D1B' : '#BBBBBB',
                            borderBottom: activeTab === tab.id ? '4px solid #1D1D1B' : 'none',
                            transition: 'all 0.2s ease',
                        }}
                        onClick={() => onTabChange(tab.id)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
        );
    };

    const renderAllSiteTraffic = () => (
        <div className="container-fluid p-0 ">
            <div className="row align-items-center mb-4">
                <div className="col-8">
                    <SearchFilter
                        className={"sofiaRegular"}
                        style={{ height: "45px", width: "350px", border: "1px solid #BBBBBB", borderRadius: "10px" }}
                        type="text"
                        placeholder="Search IP, Account, URL"
                        value={trafficSearch}
                        onChange={(e) => {
                            resetTrafficToFirstPage();
                            setTrafficSearch(e.target.value);
                        }}
                    />
                </div>
                <div className="col-4 d-flex justify-content-end gap-2">
                    <button
                        onClick={() => setAlertDrawerOpen(true)}
                        className="sofiaBold px-3 py-1 fs-14 bg-white"
                        style={{ border: "1px solid #1D1D1B", borderRadius: "10px", lineHeight: "24px" }}
                    >
                        Alert conditions
                    </button>
                    <button
                        onClick={() => setBlacklistDrawerOpen(true)}
                        className="sofiaBold px-3 py-1 fs-14"
                        style={{ backgroundColor: "#1D1D1B", color: "#FFF", border: "1px solid #1D1D1B", borderRadius: "10px", lineHeight: "24px" }}
                    >
                        Manage Blacklist
                    </button>
                </div>
            </div>

            <div className="dashboard-pages-table bg-white p-1" style={{ borderRadius: "10px", boxShadow: "0px 1px 3px rgba(0,0,0,0.1)", overflowX: "auto" }}>
                <table className="m-0 traffic-table w-100" style={{ minWidth: "1200px" }}>
                    <thead>
                        <tr>
                            <th onClick={() => handleTrafficSort('ip')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">IP {getSortIcon('ip')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('flagged')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Flagged {getSortIcon('flagged')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('sundialFlag')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Sundial Flag {getSortIcon('sundialFlag')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('googleCrawlFlag')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Google Crawl Flag {getSortIcon('googleCrawlFlag')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('visitCount')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Pages Views {getSortIcon('visitCount')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('firstVisitAt')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">First Seen {getSortIcon('firstVisitAt')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('lastVisitAt')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Last Seen {getSortIcon('lastVisitAt')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('visitDays')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Visits (days) {getSortIcon('visitDays')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('transactionCount')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Transactions {getSortIcon('transactionCount')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('checkoutVisits')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Checkout Visits {getSortIcon('checkoutVisits')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('email')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Account {getSortIcon('email')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('isRestricted')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">IP Restriction {getSortIcon('isRestricted')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('blacklistIp')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Blacklist {getSortIcon('blacklistIp')}</div>
                            </th>
                            <th onClick={() => handleTrafficSort('alertsActive')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <div className="d-flex align-items-center justify-content-center">Alerts {getSortIcon('alertsActive')}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {trafficLoading ? (
                            <tr><td colSpan={14} className="text-center py-5 sofiaBold">Loading...</td></tr>
                        ) : trafficData.length > 0 ? (
                            trafficData.map((row, idx) => (
                                <tr key={idx} onClick={() => { setSelectedTraffic(row); setTrafficDrawerOpen(true); }} style={{ cursor: "pointer" }}>
                                    <td>
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <PublicIcon sx={{ fontSize: "14px", color: "#BBBBBB" }} />
                                            <button className="btn btn-link p-0 text-primary text-decoration-underline" onClick={(e) => { e.stopPropagation(); setSelectedTraffic(row); setTrafficDrawerOpen(true); }} style={{ fontSize: "inherit", verticalAlign: "baseline" }}>{row.ip}</button>
                                        </div>
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <Switch
                                            checked={!!row.flagged}
                                            onChange={(e) => handleToggleFlag(row, 'flagged', e.target.checked)}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#FF1F1F' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#FF1F1F' }
                                            }}
                                            size="small"
                                        />
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <Switch
                                            checked={!!row.sundialFlag}
                                            onChange={(e) => handleToggleFlag(row, 'sundialFlag', e.target.checked)}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#007bff' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#007bff' }
                                            }}
                                            size="small"
                                        />
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <Switch
                                            checked={!!row.googleCrawlFlag}
                                            onChange={(e) => handleToggleFlag(row, 'googleCrawlFlag', e.target.checked)}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#28a745' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#28a745' }
                                            }}
                                            size="small"
                                        />
                                    </td>
                                    <td><button className="btn btn-link p-0 text-primary text-decoration-underline" onClick={(e) => { e.stopPropagation(); setSelectedTraffic(row); setTrafficDrawerOpen(true); }} style={{ fontSize: "inherit", verticalAlign: "baseline" }}>{row.visitCount}</button></td>
                                    <td>{moment(row.firstVisitAt).format("MM/DD/YYYY")}</td>
                                    <td>{moment(row.lastVisitAt).format("MM/DD/YYYY")}</td>
                                    <td>{row.visitDays}</td>
                                    <td>{row?.transactionCount || 0}</td>
                                    <td>{row?.checkoutVisits || 0}</td>
                                    <td>
                                        {row?.emails?.length > 0 ? (
                                            row.emails.map((email, i) => (
                                                <span key={i}>
                                                    <button className="btn btn-link p-0 text-primary text-decoration-underline" onClick={(e) => { e.stopPropagation(); handleEmailClick(email); }} style={{ fontSize: "inherit", verticalAlign: "baseline" }}>
                                                        {email}
                                                    </button>
                                                    {i < row.emails.length - 1 ? ", " : ""}
                                                </span>
                                            ))
                                        ) : (
                                            row.email ? (
                                                <button className="btn btn-link p-0 text-primary text-decoration-underline" onClick={(e) => { e.stopPropagation(); handleEmailClick(row.email); }} style={{ fontSize: "inherit", verticalAlign: "baseline" }}>
                                                    {row.email}
                                                </button>
                                            ) : "-"
                                        )}
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span style={{ marginRight: "10px" }} className={`sofiaBold ${restrictedIps.includes(row.ip) || !!row.isRestricted ? 'text-danger' : 'text-primary text-decoration-underline'}`}>
                                                {restrictedIps.includes(row.ip) || !!row.isRestricted ? "Restricted" : "Unrestricted"}
                                            </span>
                                            <Switch
                                                checked={!!row.isRestricted}
                                                onChange={(e) => handleToggleFlag(row, 'isRestricted', e.target.checked)}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#1D1D1B' },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1D1D1B' }
                                                }}
                                                size="small"
                                            />
                                        </div>
                                    </td>
                                    <td onClick={(e) => e.stopPropagation()}>
                                        <div className="d-flex align-items-center justify-content-center">
                                            {blacklistedIps.includes(row.ip) || !!row.blacklistIp ? (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); handleToggleFlag(row, 'blacklistIp', false); }}
                                                    className="sofiaBold px-2 py-1"
                                                    style={{ backgroundColor: "#FF1F1F", color: "#FFF", border: "none", borderRadius: "8px", fontSize: "12px", width: "90px", transition: "all 0.2s" }}
                                                >
                                                    Unblock IP
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); handleToggleFlag(row, 'blacklistIp', true); }}
                                                    className="sofiaBold px-2 py-1"
                                                    style={{ backgroundColor: "#1D1D1B", color: "#FFF", border: "none", borderRadius: "8px", fontSize: "12px", width: "90px", transition: "all 0.2s" }}
                                                >
                                                    Blacklist IP
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                    <td onClick={(e) => {
                                        if (row.alertSummary?.active > 0) {
                                            e.stopPropagation();
                                            setSelectedTraffic(row);
                                            setUserAlertsDrawerOpen(true);
                                        }
                                    }}>
                                        {row.alertSummary?.active > 0 && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: "pointer" }}>
                                                <ErrorOutlineIcon
                                                    style={{ color: "#FFD700" }}
                                                />
                                                <span className="sofiaBold" style={{ color: "#FFD700", fontSize: "14px" }}>
                                                    {row.alertSummary.active}
                                                </span>
                                            </Box>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan={13} className="text-center py-5 sofiaBold">No Record Found</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-center align-center p-2">
                <div className=" mx-auto">
                    <Pagination
                        count={trafficPagination.totalPages}
                        page={trafficPagination.currentPage}
                        onChange={handleChange}
                    />
                </div>
                <span className="sofiaBold" style={{ color: "#9f9f9f", fontSize: "14px" }}>
                    {trafficData.length} of {trafficPagination.count} Visits
                </span>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                .dashboard-pages-table::-webkit-scrollbar {
                    display: none;
                }
                .dashboard-pages-table {
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;  /* Firefox */
                }
                .traffic-table th {
                    color: #1D1D1B !important;
                    font-family: 'Sofia Pro Bold', sans-serif !important;
                    font-size: 14px !important;
                    background: #F9F9F9 !important;
                    border-bottom: 1px solid #EEEEEE !important;
                    padding: 15px 12px !important;
                    height: 55px !important;
                    vertical-align: middle !important;
                }
                .traffic-table tr {
                    border-bottom: 1px solid #F6F6F6 !important;
                }
                .traffic-table td {
                    font-size: 14px !important;
                    padding: 15px 12px !important;
                    vertical-align: middle !important; 
                    text-align:center !important;
                }
                .text-primary {
                    color: #007bff !important;
                }
                .text-danger {
                    color: #FF1F1F !important;
                }
                .traffic-table a {
                     text-decoration: underline !important;
                }
            `}} />
        </div>
    );



    return (
        <div className="container-fluid py-4">
            <UserTabs activeTab={activeTab} onTabChange={setActiveTab} />

            {activeTab === "site-traffic" ? (
                renderAllSiteTraffic()
            ) : (
                <>
                    <div className="row align-items-center">
                        {/* First four items on the left */}
                        <div className="col-8 d-flex gap-5">
                            <SearchFilter
                                className={"sofiaRegular"}
                                style={{ height: "40px", padding: "13px 10px !important", border: "1px solid #000000", }}
                                type="text"
                                placeholder="Search account holder"
                                value={SearchFillter.SearchQuery || ""}
                                onChange={(e) => {
                                    resetCustomersToFirstPage();
                                    setSearchFillter({
                                        ...SearchFillter,
                                        SearchQuery: e.target.value,
                                    });
                                }}
                            />

                            <CustomeSelect
                                width={"200px"}
                                className={"sofiaRegular custom"}
                                icon={KeyboardArrowDownIcon}
                                value={accountType}
                                onChange={(value) => {
                                    resetCustomersToFirstPage();
                                    handleAccountTypeChange(value);
                                }}
                                placeholder="Account Type"
                                options={[
                                    { value: "", label: "All" },
                                    { value: "Personal", label: "Personal" },
                                    { value: "Trade", label: "Trade" },
                                    { value: "Trade Plus", label: "Trade Plus" },
                                ]}

                            />
                        </div>
                        {/* Last item (Sort dropdown) aligned to the right */}
                        <div className="col d-flex justify-content-end ">
                            <CustomeSelect
                                width={"200px"}
                                className={"sofiaRegular custom"}
                                icon={KeyboardArrowDownIcon}
                                value={sort}
                                onChange={(value) => {
                                    resetCustomersToFirstPage();
                                    setSort(value);
                                }}
                                placeholder="Sort"
                                options={[
                                    { value: "asc", label: "ASC" },
                                    { value: "dsc", label: "DSC" },
                                ]}
                            />
                        </div>
                    </div>

                    <div className="sofiaRegular my-5">
                        <DashboardPagesLayout
                            pageTitle="Users"
                            subTitle="users"
                            count={pagination?.count}
                        >
                            <div className="dashboard-pages-table">
                                <table className="m-0">
                                    <thead>
                                        <tr>
                                            <th>Joined</th>
                                            <th>Account</th>
                                            <th>Last IP</th>
                                            <th> Account Type</th>
                                            <th>Account Applications</th>
                                            <th>Orders</th>
                                            <th>Cashback</th>
                                            <th>Tickets</th>
                                            <th>Mooad Boards</th>
                                            <th>Recently Viewed</th>
                                            <th>Wishlist</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Data?.length ? (
                                            <>
                                                {Data?.map((item, i) => (
                                                    <tr key={item?._id}>
                                                        <td>
                                                            {moment(item.createdAt).format("DD/MM/YYYY")}
                                                        </td>
                                                        <td> {item.email} </td>
                                                        <td> {item.lastIp} </td>
                                                        <td className="text-capitalize">
                                                            {item.accountType}
                                                        </td>
                                                        <td
                                                            style={{ width: "100px", minHeight: "36px", marginLeft: "13px" }}
                                                            className={`d-inline-flex text-capitalize justify-content-center align-items-center border mt-2 rounded  text-center p-0 ${getStatusClass(item?.businessUpgrade)}`}>
                                                            {item?.businessUpgrade}
                                                        </td>
                                                        <td>{item?.numberOfOrders}</td>
                                                        <td className="sofiaRegular fw-bold">${item?.cashBack}</td>
                                                        <td className="rounded mt-1 d-inline-flex justify-content-center align-items-center" style={{ background: "#fee9eb", border: "1px solid #fc7c88", color: "#fb1c30", padding: "4px 12px", marginLeft: "17px" }}>{item?.tickets}</td>
                                                        <td>{item?.moodBoards}</td>
                                                        <td>{0}</td>
                                                        <td>{item?.wishLists}</td>
                                                        <td>
                                                            <CustomeTableBtn
                                                                color="dark-gray"
                                                                width={"100px"}
                                                                className={"mr-2"}
                                                                styles={{ fontWeight: 400 }}
                                                                onClick={() => openManageUserDrawer(item)}

                                                            >
                                                                Manage
                                                            </CustomeTableBtn>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                <tr>
                                                    <td colSpan={9} className=" text-center">
                                                        {" "}
                                                        No Record Found
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                                <div className="d-flex justify-content-center align-center p-2">
                                    <div className=" mx-auto">
                                        <Pagination
                                            count={pagination.totalPages}
                                            page={pagination.currentPage}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <span
                                        className=" font-weight-bold"
                                        style={{ color: "#9f9f9f" }}
                                    >
                                        {Data?.length} of {pagination?.count} Users
                                    </span>
                                </div>
                            </div>
                        </DashboardPagesLayout>
                    </div>
                </>
            )}
            {selectedItem && <ManageUserDrawer open={open} onClose={closeManageUserDrawer} item={selectedItem} setData={setData} />}
            <TrafficDetailDrawer
                open={trafficDrawerOpen}
                onClose={() => setTrafficDrawerOpen(false)}
                trafficData={selectedTraffic}
                onEmailClick={handleEmailClick}
                onViewAlerts={() => {
                    setTrafficDrawerOpen(false);
                    setUserAlertsDrawerOpen(true);
                }}
                onUpdate={refreshTrafficData}
            />
            <AlertConditionDrawer
                open={alertDrawerOpen}
                onClose={() => setAlertDrawerOpen(false)}
                onUpdate={refreshTrafficData}
            />
            <BlacklistIpsDrawer
                open={blacklistDrawerOpen}
                onClose={() => setBlacklistDrawerOpen(false)}
                onUpdate={refreshTrafficData}
            />
            <UserAlertsDrawer
                open={userAlertsDrawerOpen}
                onClose={() => setUserAlertsDrawerOpen(false)}
                trafficData={selectedTraffic}
            />
        </div>
    );
};

export default ManageUsers;
